import React from "react";

const BarcodeIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
      <path fillRule="evenodd" clipRule="evenodd" d="M2 16V5H4.28571V16H2ZM5.42857 16V5H6.57143V16H5.42857ZM8.28571 16V5H9.42857V16H8.28571ZM10.5714 16V5H13.4286V16H10.5714ZM14.5714 16V5H15.7143V16H14.5714ZM16.8571 16V5H18V16H16.8571Z" fill="#6D7885"/>
    </svg>
  );
};

export default BarcodeIcon;
